import {
  TutorialDefinition,
  TutorialHighlightKey,
  TutorialId,
} from '../interfaces';
import { TUTORIAL_TEXT } from '../text';

export const languageSettingsTutorial: TutorialDefinition = {
  id: TutorialId.LanguageSettings,
  titleKey: 'guidedTutorial.languageSettings.title',
  steps: [
    {
      id: 'click-profile',
      narration: TUTORIAL_TEXT.languageSettings.step1,
      highlightTarget: TutorialHighlightKey.ProfileAvatarButton,
      awaitClickSelector: '[data-testid="user-profile-avatar-btn"]',
    },
    {
      id: 'click-settings',
      narration: TUTORIAL_TEXT.languageSettings.step2,
      highlightTarget: TutorialHighlightKey.SettingsChevron,
      awaitClickSelector: '[data-testid="user-profile-settings-btn"]',
    },
    {
      id: 'click-language-dropdown',
      narration: TUTORIAL_TEXT.languageSettings.step3,
      highlightTarget: TutorialHighlightKey.LanguageDropdown,
      awaitClickSelector: '[data-testid="user-profile-language-select"]',
    },
  ],
};
